import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Button, Container, Typography } from '@mui/material';
import { ForbiddenIllustration } from 'src/assets';
import { MotionContainer, varBounce } from 'src/components/animate';
import Page from 'src/components/Page';
import useSettings from '../hooks/useSettings';
import { LoginRoot, RootRoute } from 'src/backoffice-app-code/routes/Routes';
// components
// assets

// ----------------------------------------------------------------------

export default function ForbiddenPage() {
  const { themeStretch } = useSettings();

  return (
    <Page title="Page Two">
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Box sx={{ textAlign: 'center' }}>
          <Helmet>
            <title> 403 Forbidden</title>
          </Helmet>

          <MotionContainer>
            <m.div variants={varBounce().in}>
              <Typography variant="h3" paragraph>
                No permission
              </Typography>
            </m.div>

            <m.div variants={varBounce().in}>
              <Typography sx={{ color: 'text.secondary' }}>
                The page you're trying access has restricted access.
                <br />
                Please refer to your system administrator
              </Typography>
            </m.div>

            <m.div variants={varBounce().in}>
              <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
            </m.div>

            <Button to={RootRoute} component={RouterLink} size="large" variant="contained">
              Go to Home
            </Button>
            <br />
            <br />
            <Button to={LoginRoot} component={RouterLink} size="large" variant="contained">
              Go to Login
            </Button>
          </MotionContainer>
        </Box>
      </Container>
    </Page>
  );
}
